import React, { useMemo } from 'react';
import { Table } from 'reactstrap';
import { reduxForm } from 'redux-form';
import CheckIcon from 'mdi-react/CheckIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import { partial } from '../../../util/translation/translation';
import { formatDate } from '../../../util/date-and-time';

const InvitesCard = ({ invites, participantSearch }) => {
  const s = partial('shared');
  const p = partial('EventParticipantsPage');
  const search = participantSearch.trim().toLowerCase();
  const filteredInvites = useMemo(
    () =>
      invites.filter((invite) => invite.email?.toLowerCase().includes(search)),
    [invites, search]
  );

  const renderInvites = () => {
    if (!filteredInvites.length) {
      return (
        <tr>
          <td colSpan={3} className="text-muted text-center">
            {search
              ? p('noSearchResults', { query: participantSearch })
              : p('noInvites')}
          </td>
        </tr>
      );
    }
    return filteredInvites.map((invite) => {
      const registered = !!invite.registeredAt;
      return (
        <tr key={`renderInvites-${invite.id}`}>
          <td className="table-stack__primary">{invite.email}</td>
          <td data-label={p('hasRegistered')}>
            <div className="status-dot-group">
              <span
                className={`status-dot ${
                  registered ? 'status-dot--on' : 'status-dot--off'
                }`}
              >
                {registered ? <CheckIcon /> : <CloseIcon />}
              </span>
              {registered && formatDate(invite.registeredAt)}
            </div>
          </td>
          <td data-label={p('sentAt')}>{formatDate(invite?.createdAt)}</td>
        </tr>
      );
    });
  };

  return (
    <Table responsive striped className="table--roomy table--stack">
      <thead>
        <tr>
          <th>{s('email')}</th>
          <th>{p('hasRegistered')}</th>
          <th>{p('sentAt')}</th>
        </tr>
      </thead>
      <tbody>{renderInvites()}</tbody>
    </Table>
  );
};

const reduxF = reduxForm({
  form: 'EventsPariticipantForm',
  enableReinitialize: true,
});

export default reduxF(InvitesCard);
